<template>
  <path pid="0" d="M23.64 21.22zM24.34 20.84l-.07.07zM19 9h-.12a1 1 0 00-.88 1v6.59L7.71 6.29a1 1 0 00-1.42 0l-.08.1a1 1 0 00.08 1.32L16.59 18H10a1 1 0 000 2H19.44l.08-.05.15-.16a.35.35 0 00.05-.08v-.06a.17.17 0 010-.05v-.06a.25.25 0 000-.07v-.05a.13.13 0 010-.06V10A1 1 0 0019 9z"/>
</template>
